import { useIntl } from 'react-intl'

import { classMessages } from './messages'

export const LineClass = ({ lineClass }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  return <div>{classMessages[lineClass] && intl.formatMessage(classMessages[lineClass])}</div>
}
